import { render, staticRenderFns } from "./Gallery23.vue?vue&type=template&id=60b693fa&scoped=true&"
import script from "./Gallery23.vue?vue&type=script&lang=js&"
export * from "./Gallery23.vue?vue&type=script&lang=js&"
import style0 from "./Gallery23.vue?vue&type=style&index=0&id=60b693fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b693fa",
  null
  
)

export default component.exports